module.exports = __webpack_public_path__ + "img/tree_2_3.899e95c5.png";